import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gold-ellipse-icon",
  "use": "gold-ellipse-icon-usage",
  "viewBox": "0 0 3 3",
  "content": "<symbol viewBox=\"0 0 3 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"gold-ellipse-icon\">\n<circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\" fill=\"#AD903C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol